/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetFnsInn200ResponseDataInner
 */
export interface GetFnsInn200ResponseDataInner {
  /**
   * Полное наименование с ОПФ
   * @type {string}
   * @memberof GetFnsInn200ResponseDataInner
   */
  name: string
  /**
   * Актуальный адрес
   * @type {string}
   * @memberof GetFnsInn200ResponseDataInner
   */
  address: string
  /**
   * ИНН
   * @type {string}
   * @memberof GetFnsInn200ResponseDataInner
   */
  inn: string
  /**
   * ОГРН
   * @type {string}
   * @memberof GetFnsInn200ResponseDataInner
   */
  ogrn: string
}

/**
 * Check if a given object implements the GetFnsInn200ResponseDataInner interface.
 */
export function instanceOfGetFnsInn200ResponseDataInner(
  value: object
): value is GetFnsInn200ResponseDataInner {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('inn' in value) || value['inn'] === undefined) return false
  if (!('ogrn' in value) || value['ogrn'] === undefined) return false
  return true
}

export function GetFnsInn200ResponseDataInnerFromJSON(
  json: any
): GetFnsInn200ResponseDataInner {
  return GetFnsInn200ResponseDataInnerFromJSONTyped(json, false)
}

export function GetFnsInn200ResponseDataInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetFnsInn200ResponseDataInner {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    address: json['address'],
    inn: json['inn'],
    ogrn: json['ogrn'],
  }
}

export function GetFnsInn200ResponseDataInnerToJSON(
  value?: GetFnsInn200ResponseDataInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    address: value['address'],
    inn: value['inn'],
    ogrn: value['ogrn'],
  }
}
